import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { v4 as uuid } from 'uuid'

import SwapFieldsButton from 'components/swap-fields-button'
import { SEARCH_BOX } from 'constants/searchBox'
import e2eClasses from 'helpers/automation'
import { isMobileOrTablet } from 'helpers/utils'
import { mapMediaType } from 'selectors/mediaType'

import AutocompleteWithHistory from '../autocomplete-with-history'
import { AirportContainer, Label } from '../styled'

const AirportInput = ({
  index,
  isConference,
  isResearch,
  selected,
  error,
  name,
  e2eClass,
  fieldLabel,
  isCampaignRestricted,
  suggestions,
  exclusionValue,
  mobileOrTablet,
  swapOriginDestination,
  onAutoCompleteChange,
  handleInputChange,
  fieldType,
  suggestionType,
  fieldPosition,
  onFetchSuggestions,
  handleSuggestionSelected,
  swapButtonOnMobile,
  isExpanded
}) => {
  const showSwapButton = swapButtonOnMobile && mobileOrTablet && !isCampaignRestricted
  const flatStyle = isResearch || isConference
  const inputId = useMemo(() => uuid(), [])

  return (
    <AirportContainer isConference={isConference}>
      <Label e2eClass={e2eClasses(e2eClass)} isResearch={isResearch} forId={inputId}>
        {fieldLabel}
      </Label>
      <AutocompleteWithHistory
        placeholder={fieldLabel}
        value={selected}
        error={error}
        isExpanded={isExpanded}
        isResearch={isResearch}
        name={name}
        e2eClass={e2eClasses(e2eClass)}
        id={inputId}
        flatStyle={flatStyle}
        rightButton={
          showSwapButton && (
            <SwapFieldsButton onClick={() => swapOriginDestination(index)} rotateInTablet />
          )
        }
        onChange={value => onAutoCompleteChange(index, value, fieldType)}
        index={index}
        handleInputChange={ev => handleInputChange(ev, index, fieldType, suggestionType)}
        fetchedSuggestions={suggestions}
        exclusionValue={exclusionValue}
        handleSuggestionSelected={suggestion =>
          handleSuggestionSelected(suggestion, index, fieldType, fieldPosition)
        }
        minLength={SEARCH_BOX.AUTOSUGGEST_MIN_LENGTH}
        storageKey={!isCampaignRestricted && SEARCH_BOX.STORAGE_KEY}
        fetchSuggestions={onFetchSuggestions}
      />
    </AirportContainer>
  )
}

AirportInput.propTypes = {
  isConference: PropTypes.bool,
  isResearch: PropTypes.bool,
  isCampaignRestricted: PropTypes.bool
}

const mapStateToProps = state => ({
  mobileOrTablet: isMobileOrTablet(mapMediaType(state))
})

export default connect(mapStateToProps)(AirportInput)
